import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useAppDispatch as useDispatch } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import {
  SIGN_IN_FIRST_HAIRCARE_CONSULTATION,
  signInFirstConsultationRouteByCategory,
} from '../constants';

import consultationCategoryProp from 'PropTypes/consultationProps';

import { trackHeapEvent } from 'dux/tracking/actions';
import { actions } from 'dux/signup/slice';

import BaseScene from './BaseScene';

const StyledButtonSecondary = styled(Button)`
  color: ${theme.colors.primary[400]};
  border-color: ${theme.colors.primary[400]};

  :hover {
    color: ${theme.colors.neutral[100]};
    border-color: ${theme.colors.neutral[100]};
    background-color: ${theme.colors.neutral['700']};
  }
`;

/* XXX: Need to align on visual aspect with product design if we want to merge
 * it with MagicLinkSent */
const ConsultationMagicLinkSent = ({ background, children, consultationCategory, firstname }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(trackHeapEvent('MagicLinkSent Viewed'));
  }, []);

  const title = !firstname ? 'Check your email!' : `Nice to see you again ${firstname}!`;
  const desc = !firstname
    ? 'You just received a link to log you in.'
    : 'Check your email, you just received a link to log you in.';
  const ctaLabel = 'I did not receive a link';
  const ctaLink =
    signInFirstConsultationRouteByCategory[consultationCategory] ||
    SIGN_IN_FIRST_HAIRCARE_CONSULTATION;

  const onClick = () => {
    dispatch(actions.setMagicLinkSent(false));
  };

  return (
    <BaseScene background={background} justifyContent="start">
      {children}
      <Spacer size={71 - 16} />
      <Typography align="center" paragraph variant="h2">
        {title}
      </Typography>
      <Typography align="center" variant="p1">
        {desc}
      </Typography>
      <Spacer size={48} />

      <a href={ctaLink}>
        {!firstname ? (
          <Button onClick={onClick} variant="underlined">
            {ctaLabel}
          </Button>
        ) : (
          <StyledButtonSecondary onClick={onClick} variant="noir">
            {ctaLabel}
          </StyledButtonSecondary>
        )}
      </a>
    </BaseScene>
  );
};

ConsultationMagicLinkSent.defaultProps = {
  firstname: '',
  children: null,
  background: 'none',
};

ConsultationMagicLinkSent.propTypes = {
  consultationCategory: consultationCategoryProp.isRequired,
  firstname: PropTypes.string,
  /**
   * children is currently used for adding a progress tracker when MagicLinkSent
   * is called from the Consultation.
   */
  children: PropTypes.node,
  background: PropTypes.string,
};

export default ConsultationMagicLinkSent;
